/* eslint no-restricted-syntax: "off" */

import events from '../map-events/map-events';

class HoverMapModule {
    constructor(params, renderFunction, uniqueId) {
        this.currentRegion = {
            region: undefined,
            mapId: undefined,
        };

        this.params = {
            ...params,
        };

        // keep track of zoomed-in maps:
        this.zoomedIn = false;
        this.currentlyOverflow = false;
        this.currentlyVisible = false;
        this.boxPosition = {
            above: false,
            left: false,
        };

        this.mouseOffset = 10;

        this.usingMobileDevice = false;

        this.params.rootScope.querySelector('div').addEventListener('touchstart', () => {
            this.usingMobileDevice = true;
        }, false);

        events.on('vj-map', (eventObject) => {
            const { type, content, id } = eventObject;

            // ignore all messages with different id:
            if (uniqueId !== id) return;

            if (type === 'mouse-enter') {
                // ignore this event on mobile:
                if (this.usingMobileDevice) return;

                this.currentRegion = {
                    region: content,
                    mapId: id,
                };

                const hoverDivContent = this.params.rootScope.querySelector('.vj-map-hover__content');
                hoverDivContent.style.display = 'block';

                const hoverDivResults = this.params.rootScope.querySelector('.vj-map-hover__results');

                // add random text to div:
                renderFunction(content);

                hoverDivResults.style.visibility = 'hidden';
                this.currentlyVisible = false;
                this.currentlyOverflow = false;
                this.boxPosition = {
                    above: false,
                    left: false,
                };
            }
            else if (type === 'mouse-leave') {
                this.currentRegion = {
                    region: undefined,
                    mapId: undefined,
                };

                const hoverDivContent = this.params.rootScope.querySelector('.vj-map-hover__content');
                hoverDivContent.style.display = 'none';

                const hoverDivResults = this.params.rootScope.querySelector('.vj-map-hover__results');

                hoverDivResults.style.visibility = 'hidden';
                this.currentlyVisible = false;
                this.currentlyOverflow = false;
                this.boxPosition = {
                    above: false,
                    left: false,
                };
            }
            else if (type === 'zoom-started') {
                this.zoomedIn = true;
                const hoverDivContent = this.params.rootScope.querySelector('.vj-map-hover__content');
                hoverDivContent.style.display = 'none';
            }
        });

        this.params.rootScope.addEventListener('mousemove', (event) => {
            // ignore if on mobile:
            if (this.usingMobileDevice) return;

            // if a region is hovered:
            if (this.currentRegion.region !== undefined && !this.zoomedIn) {
                const { clientX, clientY } = event;
                // on first display, we calculate all positions:
                if (!this.currentlyVisible) {
                    const hoverDiv = this.params.rootScope.querySelector('.vj-map-hover');
                    const hoverBoundingbox = hoverDiv.getBoundingClientRect();

                    const hoverDivPos = {
                        x: hoverBoundingbox.left - this.mouseOffset,
                        y: hoverBoundingbox.top - this.mouseOffset,
                    };

                    const hoverDiff = {
                        x: clientX - hoverDivPos.x,
                        y: clientY - hoverDivPos.y,
                    };

                    const hoverDivContent = this.params.rootScope.querySelector('.vj-map-hover__content');
                    hoverDivContent.style.transform = `translate(${hoverDiff.x}px, ${hoverDiff.y}px)`;
                    const hoverDivResults = this.params.rootScope.querySelector('.vj-map-hover__results');
                    if (!this.isElementFullyVisible(hoverDivResults)) {
                        this.currentlyOverflow = true;

                        // calculate best position:
                        // if more space above or below:
                        if (clientY > (window.innerHeight / 2)) {
                            // more space above:
                            this.boxPosition.above = true;
                        }
                        else {
                            // more space below:
                        }

                        // if more space left or right:
                        if (clientX > (window.innerWidth / 2)) {
                            // more space left:
                            this.boxPosition.left = true;
                        }
                        else {
                            // more space right:
                        }
                    }
                    else {
                        // element fully visible
                    }

                    this.currentlyVisible = true;
                }

                const hoverDiv = this.params.rootScope.querySelector('.vj-map-hover');
                const hoverBoundingbox = hoverDiv.getBoundingClientRect();

                const hoverDivPos = {
                    x: hoverBoundingbox.left - this.mouseOffset,
                    y: hoverBoundingbox.top - this.mouseOffset,
                };

                const hoverDiff = {
                    x: clientX - hoverDivPos.x,
                    y: clientY - hoverDivPos.y,
                };

                const hoverDivResults = this.params.rootScope.querySelector('.vj-map-hover__results');

                // detect overflow:
                if (this.currentlyOverflow) {
                    // if more space above or below:
                    if (this.boxPosition.above) {
                        hoverDiff.y -= hoverBoundingbox.height + (this.mouseOffset * 2);
                    }
                    else {
                        // more space below
                    }

                    // if more space left or right:
                    if (this.boxPosition.left) {
                        hoverDiff.x -= hoverBoundingbox.width + (this.mouseOffset * 2);
                    }
                    else {
                        // more space right
                    }
                }

                const hoverDivContent = this.params.rootScope.querySelector('.vj-map-hover__content');
                hoverDivContent.style.transform = `translate(${hoverDiff.x}px, ${hoverDiff.y}px)`;

                if (hoverDivResults.style.visibility !== 'visible') {
                    hoverDivResults.style.visibility = 'visible';
                }
            }
        });
    }

    isElementFullyVisible(element) {
        const boundingBox = element.getBoundingClientRect();

        if (boundingBox.top < 0) {
            return false;
        }

        if (boundingBox.left < 0) {
            return false;
        }

        if (boundingBox.bottom > window.innerHeight) {
            return false;
        }

        if (boundingBox.right > window.innerWidth) {
            return false;
        }

        return true;
    }
}

export default HoverMapModule;
